import {CommonModule} from '@angular/common';
import {Component, Input, OnInit, inject} from '@angular/core';
import {Router, RouterModule} from '@angular/router';

import {LoginOauthComponent} from 'src/app/components/library/login-oauth/login-oauth.component';
import {DxFormModule} from 'devextreme-angular/ui/form';
import {DxLoadIndicatorModule} from 'devextreme-angular/ui/load-indicator';
import {DxButtonModule, DxButtonTypes} from 'devextreme-angular/ui/button';
import notify from 'devextreme/ui/notify';
import {AuthService, ThemeService} from 'src/app/services';
import {catchError, finalize} from "rxjs/operators";
import {EMPTY} from "rxjs";

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    imports: [
        CommonModule,
        RouterModule,
        DxFormModule,
        DxLoadIndicatorModule,
        DxButtonModule,
    ]
})
export class LoginFormComponent implements OnInit {
    @Input() resetLink = '/auth/reset-password';

    @Input() createAccountLink = '/auth/register';

    private authService = inject(AuthService);

    private router = inject(Router);

    private themeService = inject(ThemeService);

    btnStylingMode: DxButtonTypes.ButtonStyle;

    passwordMode = 'password';

    loading = false;

    formData: any = {};

    passwordEditorOptions = {
        placeholder: 'Password',
        stylingMode: 'filled',
        mode: this.passwordMode,
        value: '',
    }

    emailEditorOptions = {
        placeholder: 'Email',
        stylingMode: 'filled',
        mode: 'email',
        value: '',
    }

    ngOnInit(): void {
        this.themeService.isDark$.subscribe((value: boolean) => {
            this.btnStylingMode = value ? 'outlined' : 'contained';
        });
    }

    async onSubmit(e: Event) {
        e.preventDefault();
        const {email, password} = this.formData;
        this.loading = true;

        this.authService.logIn(email, password).pipe(
            catchError((errors: Array<any>) => {
                let errMsg = errors.pop();
                notify({message: errMsg.message, position: 'bottom center'}, 'error', 3000);
                return EMPTY;
            }),
            finalize(() => this.loading = false)
        ).subscribe();
    }

    onCreateAccountClick = async () => {
        await this.router.navigate([this.createAccountLink]);
    };
}

